import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useRideHubInfo } from "@ryde/redux";
import { IRideDto } from "@ryde/shared";

import {
  FramerTooltip,
  HUB_TOOLTIP_MOUSE_LEAVE_DELAY,
  HubRelatedRideTooltipContent,
} from "../../../../common";

interface IHubIndicatorRides {
  rideDto: Partial<IRideDto>;
}

export const HubIndicatorRides: FC<IHubIndicatorRides> = ({ rideDto }) => {
  const hubInfo = useRideHubInfo(rideDto);

  if (!hubInfo) {
    return null;
  }

  const { hasMain, hasPersonal, hasCompanionPassengers } = hubInfo;
  const MainIcon = hasCompanionPassengers
    ? SVG_MUI.HubMainCompanion4SVG
    : SVG_MUI.HubMain4SVG;
  const PersonalIcon = hasCompanionPassengers
    ? SVG_MUI.HubPersonalCompanion4SVG
    : SVG_MUI.HubPersonal4SVG;

  return (
    <>
      {hasMain && (
        <FramerTooltip
          content={
            <HubRelatedRideTooltipContent
              rideDto={rideDto}
              segment="main"
              hasCompanionPassengers={hasCompanionPassengers}
            />
          }
          mouseLeaveDelay={HUB_TOOLTIP_MOUSE_LEAVE_DELAY}
        >
          <span className="hub_icon_wrapper">
            <MainIcon className="hub-icon main" />
          </span>
        </FramerTooltip>
      )}
      {hasPersonal && (
        <FramerTooltip
          content={
            <HubRelatedRideTooltipContent
              rideDto={rideDto}
              segment="personal"
              hasCompanionPassengers={hasCompanionPassengers}
            />
          }
          mouseLeaveDelay={HUB_TOOLTIP_MOUSE_LEAVE_DELAY}
        >
          <span className="hub_icon_wrapper">
            <PersonalIcon className="hub-icon personal" />
          </span>
        </FramerTooltip>
      )}
    </>
  );
};
